import { LoaderFunctionArgs, defer } from 'react-router-dom';
import { ILeaderboard } from '@kattana-io/common';
import { CexAPI } from '../../store/createStore';

export type competitionLoaderDataType = ILeaderboard[] | null;

const competitionLoader = async ({ params, request }: LoaderFunctionArgs) => {
  const exchange = params.exchange || 'binance';

  const leaderboard = CexAPI.fetchLeaderboard(exchange, {
    signal: request.signal,
  });

  return defer({
    leaderboard,
  });
};

export default competitionLoader;
